module.exports = __webpack_public_path__ + "static/media/bg-5.120158ed.png";